module.exports = __webpack_public_path__ + "img/utilityvalve_parked.befd9674.svg";